import React from "react";
import { Box, Typography } from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import ClearIcon from '@mui/icons-material/Clear';
import { BreadcrumbPage } from "../../shared";
import Help from "@material-ui/icons/Help";
import ZoomOutMapIcon from '@mui/icons-material/ZoomOutMap';
import CancelIcon from '@mui/icons-material/Cancel';
import DownloadIcon from '@mui/icons-material/Download';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import Button from '@mui/material/Button';
import ctrl from '../Helpsection_images/ctrl.jpg';
import clear from '../Helpsection_images/clear.jpg';
import cancel from '../Helpsection_images/cancel.jpg';
import applyfilter from '../Helpsection_images/applyfilter.jpg';
import updatechart from '../Helpsection_images/updatechart.jpg';
import reset from '../Helpsection_images/reset.jpg';
import shiplist from '../Helpsection_images/shiplist.jpg';
import selectedassets from '../Helpsection_images/selectedassets.jpg';
import selectedassetsclear from '../Helpsection_images/selectedassetsclear.jpg';
import enviroment from '../Helpsection_images/enviroment.jpg';
import commercial from '../Helpsection_images/commercial.jpg';
import cold_flow from '../Helpsection_images/cold_flow.jpg';
import assets from '../Helpsection_images/assets.jpg';
import assets1 from '../Helpsection_images/assets1.jpg';

export default function TrendsBreadCrumb(props) {

    const BreadcrumbList = [{ name: "Trends", url: "" }];
    const [openform,setOpenform]=React.useState(false);
    const [scroll, setScroll] = React.useState('paper');

    const handleClickOpenForm = () => {
        setOpenform(true);
    };

    const handleClickClose = () => {
        setOpenform(false);
    };

return(
    <Grid className="breadcrum trends" item xs={12}>
        <BreadcrumbPage rows = {BreadcrumbList} icon={<Help onClick = {handleClickOpenForm} />} />          
        <div>
            <Box component="div" className="pos_relative">
                <Dialog
                    open={openform}
                    scroll={scroll}
                    aria-labelledby="scroll-dialog-title"
                    aria-describedby="scroll-dialog-description"
                >
                    <DialogTitle id="scroll-dialog-title" color="white">Trends</DialogTitle>
                    <DialogContent dividers={scroll === 'paper'}>
                        <DialogContentText
                            id="scroll-dialog-description"
                            tabIndex={-1}
                        >
                            <p className="subtitle">Help On Filter Panel</p><br />
                            <img className="maxwidth100" src="/assets/images/Trends_page_fuel_help_section1.jpg"></img><br /><br />
                            <p>
                                <li>Click and type on the fields to see the options</li><br />
                                <li>For multiple selections hold <img src={ctrl} width="40px" height="40px" /> to select options from the list</li><br />
                                <li>Click <ClearIcon color="disabled" /> to clear all the selection in a particular field<img src={clear} alt="" width="300px" height="300px" /></li><br />
                                <li>Click <CancelIcon color="disabled" /> to remove individual selection in a particular field<img src={cancel} alt="" width="300px" height="300px" /> </li><br />
                                <li>Click <CheckBoxOutlineBlankIcon/> to view both Historic and Current vessels</li><br />
                                <li>Click on <img src={applyfilter} alt="" width="100px" height="100px" /> to apply selected filters</li><br />
                                <li>Click on <img src={reset} alt="" width="70px" height="70px" /> will revert changes made in filter panel and set it to default global filter values</li><br />
                                <p><span style={{ color: "#ff4717" }}>Note:</span> If global filters are not set then, Reset it will set filter values to blank</p>
                            </p><br />
                            <p className="subtitle">Help On Fuel update Chart</p><br />
                            <img className="maxwidth100" src="/assets/images/Trends_page_fuel_help_section2.jpg"></img><br /><br />
                            <img className="maxwidth100" src="/assets/images/Trends_page_fuel_help_section3.jpg"></img><br /><br />
                            <p>
                                <li>Select ships from ship list in left corner</li><br />
                                <li>And can select multiple ships at the same time from the list <img src={shiplist} alt="" width="120px" height="120px" /></li><br />
                                <li>Selected ships will display on the top as the list <img src={selectedassets} alt="" width="270px" height="270px" /></li><br />
                                <li>Click <ClearIcon color="disabled" /> to remove individual selection in the list <img src={selectedassetsclear} alt="" width="270px" height="270px" /></li><br />
                                <li>Select any check box(Multiple Selection) in Environmental Social and Governance section <img src={enviroment} alt="" width="270px" height="270px" /></li><br />
                                <li>Select any check box(Multiple Selection) in Commercial section <img src={commercial} alt="" width="300px" height="300px" /></li><br />
                                <li>Select any check box(Multiple Selection) in Cold-Flow section <img src={cold_flow} alt="" width="300px" height="300px" /></li><br />
                                <li>Select any check box(Multiple Selection) in Asset Protection - HSFO/VLSFO section <img src={assets} alt="" width="300px" height="300px" /></li><br />
                                <li>Select any check box(Multiple Selection) in Asset Protection - Distillates section <img src={assets1} alt="" width="300px" height="300px" /></li><br />
                                <li>After selecting ships and checkbox in each section click on <img src={updatechart} alt="" width="100px" height="100px" /></li><br />
                                <li>Chart will display in each section related selected check box and ship details</li><br />
                                <li>Click on the <ZoomOutMapIcon /> will expand the section and will display only that section</li><br />
                                <li>Click on the <CancelIcon color="primary" /> will close the expanded section</li><br />
                                <li>Click on the <DownloadIcon/> to downlaod the Chart Data in to the excel</li><br />
                                <li>Click on the dots will open the PDF in another tab ,If there is no pdf(data) will not open</li>
                            </p>
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleClickClose}>Close</Button>
                    </DialogActions>
                </Dialog>
            </Box>
        </div>
    </Grid>
    );
}